<template>
    <select :name="name" :class="'form-control'" @change="updateValue($event.target.value)">
        <option v-for="date in dateType" :value="date" :selected="date == current">{{ date }}</option>
    </select>
</template>

<script>
export default {
    name: "DatePicker",

    props: {
        dateType: {
            type: Object,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        current: {
            type: [String, Number],
            required: true
        },
    },

    methods: {
        updateValue: function (value) {
            this.$emit('update:value', value);
        }
    }
}
</script>

<style scoped>

</style>
